import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DeleteWarningIcon } from '../ui/icons';
import {useDeleteModal} from "./useDeleteUserModal";

function DeleteUserModal ({id,name}:{id:string,name:string}) {
  const { handleDeleteButtonClick,show,handleClose,handleShow } = useDeleteModal(id);

return (
    <>
      <div onClick={handleShow}>
        Delete
      </div>
      <Modal show={show} onHide={handleClose} className='modal-container disable-modal' centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className='delete-heading'>
              <DeleteWarningIcon></DeleteWarningIcon>
              <h1>Delete User</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to Delete {show? name : null}’s account?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button className='btn-delete' onClick={handleDeleteButtonClick}>
          Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteUserModal;